import { useCallback, useContext } from 'react';
import { CommonDataContext } from '../context/common.context';
import { LocationDetail } from '../types/location/location-detail';
import { RegionDetail } from '../types/location/region-detail';

interface useLocationsBundle {
    locations: LocationDetail[];
    regions: RegionDetail[];
    getLocation: (id: number) => LocationDetail | null;
    getRegion: (id: number | null) => RegionDetail;
}
const useLocations = (): useLocationsBundle => {
    const { locations, regions } = useContext(CommonDataContext);

    const getLocation = useCallback(
        (id: number): LocationDetail | null => {
            return locations.find((l) => l.locationId === id) ?? null;
        },
        [locations],
    );

    const getRegionInner = useCallback((id: number, list: RegionDetail[]): RegionDetail => {
        for (let i = 0; i < list.length; i++) {
            if (list[i].regionId === id) return list[i];
            if (list[i].childRegions && list[i].childRegions.length > 0) {
                const inner = getRegionInner(id, list[i].childRegions);
                if (inner.regionId === id) return inner;
            }
        }
        return { regionId: -1, name: '', childRegions: [] as RegionDetail[], locations: [] as LocationDetail[] };
    }, []);
    const getRegion = useCallback(
        (id: number | null): RegionDetail => {
            if (!id) {
                return { childRegions: regions, locations: [] as LocationDetail[] } as RegionDetail;
            }
            return getRegionInner(id, regions);
        },
        [getRegionInner, regions],
    );

    return {
        locations,
        regions,
        getLocation,
        getRegion,
    };
};

export default useLocations;
